
import React from 'react'

const AppContext = React.createContext({
  data: {
  	app: {},
  	isReady: false,
  	toastr: null
  }
})

const setState = (key, value, data) => {
	var tmp = {...data}
	const path = key.split(".").filter(item => !!item)
	if(path.length == 0){
		tmp = value
	}else if(path.length == 1){
		tmp[path[0]] = value
	}else if(path.length == 2){
		if(!tmp[path[0]]) tmp[path[0]] = {}
		tmp[path[0]][path[1]] = value
	}else if(path.length == 3){
		if(!tmp[path[0]]) tmp[path[0]] = {}
		if(!tmp[path[0]][path[1]]) tmp[path[0]][path[1]] = {}
		tmp[path[0]][path[1]][path[2]] = value
	}else if(path.length == 4){
		if(!tmp[path[0]]) tmp[path[0]] = {}
		if(!tmp[path[0]][path[1]]) tmp[path[0]][path[1]] = {}
		if(!tmp[path[0]][path[1]][path[2]]) tmp[path[0]][path[1]][path[2]] = {}
		tmp[path[0]][path[1]][path[2]][path[3]] = value
	}else if(path.length == 5){
		if(!tmp[path[0]]) tmp[path[0]] = {}
		if(!tmp[path[0]][path[1]]) tmp[path[0]][path[1]] = {}
		if(!tmp[path[0]][path[1]][path[2]]) tmp[path[0]][path[1]][path[2]] = {}
		if(!tmp[path[0]][path[1]][path[2]][path[3]]) tmp[path[0]][path[1]][path[2]][path[3]] = {}
		tmp[path[0]][path[1]][path[2]][path[3]][path[4]] = value
	}else{
		return null
	}
	return tmp
}

export { setState }

export default AppContext